module.exports = __webpack_public_path__ + "static/img/partner_10.a9af737.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_10.png
// module id = ws/B
// module chunks = 0